import { Effect } from "../../Materials/effect";
var name = 'pointCloudVertex';
var shader = "#ifdef POINTSIZE\ngl_PointSize=pointSize;\n#endif";
Effect.IncludesShadersStore[name] = shader;
/** @hidden */
export var pointCloudVertex = { name: name, shader: shader };
//# sourceMappingURL=pointCloudVertex.js.map